import React from 'react';

export const Trackers: React.FC = () => {
  return (
    <>
      {/* <LogRocketTracking /> Disabling for now as we dont use logrocket */}
      {/* more trackers here */}
    </>
  );
};
